"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var escapeRegex_1 = __importDefault(require("../escapeRegex"));
/**
* Remove the given needle from the start of string
*
* @param string needle
* @return string
*/
function rtrim(string, needle) {
    if (needle === void 0) { needle = ' '; }
    var pattern = escapeRegex_1.default(needle) + '+$', regex = new RegExp(pattern, 'g');
    return string.replace(regex, "");
}
exports.default = rtrim;
;
//# sourceMappingURL=rtrim.js.map